import { render, staticRenderFns } from "./ClonarBolsa.vue?vue&type=template&id=f092b87c"
import script from "./ClonarBolsa.vue?vue&type=script&lang=js"
export * from "./ClonarBolsa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports